import { render, staticRenderFns } from "./bondCate.vue?vue&type=template&id=2f096212&scoped=true&"
import script from "./bondCate.vue?vue&type=script&lang=js&"
export * from "./bondCate.vue?vue&type=script&lang=js&"
import style0 from "./bondCate.vue?vue&type=style&index=0&id=2f096212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f096212",
  null
  
)

export default component.exports